module.exports = __webpack_public_path__ + "img/icons8-jaguar.d6789883.svg";